import {
  BriefcaseBusiness,
  Building2,
  Car,
  Coffee,
  Dumbbell,
  Handshake,
  Landmark,
  Library,
  Hotel,
  House,
  Mail,
  Plane,
  PackageCheck,
  PawPrint,
  ReceiptText,
  Scissors,
  ShoppingBasket,
  ShoppingBag,
  Stethoscope,
  Smartphone,
  GraduationCap,
  UserRoundCheck,
  UsersRound,
  TramFront,
  VolumeX,
} from "lucide-react";

export const scenarioIcons = {
  "market-checkout": ShoppingBasket,
  "cafe-order": Coffee,
  "airport-gate": Plane,
  "job-small-talk": BriefcaseBusiness,
  "rent-apartment": Building2,
  "doctor-visit": Stethoscope,
  "immigration-entry": ReceiptText,
  "hotel-checkin": Hotel,
  "transport-ride": TramFront,
  "shopping-return": ShoppingBag,
  "neighbor-intro": House,
  "neighbor-noise": VolumeX,
  "neighbor-package": PackageCheck,
  "coworker-handoff": UsersRound,
  "boss-checkin": UserRoundCheck,
  "supervisor-shift": BriefcaseBusiness,
  "customer-help": Handshake,
  "bank-account": Landmark,
  "pharmacy-pickup": Stethoscope,
  "post-office-mail": Mail,
  "haircut-appointment": Scissors,
  "gym-membership": Dumbbell,
  "library-card": Library,
  "school-teacher": GraduationCap,
  "car-repair": Car,
  "phone-store-plan": Smartphone,
  "internet-support": Smartphone,
  "dentist-reschedule": Stethoscope,
  "lost-item-report": PackageCheck,
  "dmv-license": ReceiptText,
  "laundry-machine": House,
  "apartment-maintenance": Building2,
  "vet-visit": PawPrint,
  "daycare-pickup": UsersRound,
  "community-event": Handshake,
  "delivery-wrong-order": Coffee,
  "parking-ticket": Car,
};

export const scenarioSurface = {
  "market-checkout": "surface-mint",
  "cafe-order": "surface-yellow",
  "airport-gate": "surface-blue",
  "job-small-talk": "surface-lavender",
  "rent-apartment": "surface-mint",
  "doctor-visit": "surface-yellow",
  "immigration-entry": "surface-blue",
  "hotel-checkin": "surface-lavender",
  "transport-ride": "surface-mint",
  "shopping-return": "surface-yellow",
  "neighbor-intro": "surface-blue",
  "neighbor-noise": "surface-yellow",
  "neighbor-package": "surface-mint",
  "coworker-handoff": "surface-lavender",
  "boss-checkin": "surface-blue",
  "supervisor-shift": "surface-yellow",
  "customer-help": "surface-mint",
  "bank-account": "surface-blue",
  "pharmacy-pickup": "surface-yellow",
  "post-office-mail": "surface-mint",
  "haircut-appointment": "surface-lavender",
  "gym-membership": "surface-blue",
  "library-card": "surface-yellow",
  "school-teacher": "surface-mint",
  "car-repair": "surface-lavender",
  "phone-store-plan": "surface-yellow",
  "internet-support": "surface-mint",
  "dentist-reschedule": "surface-lavender",
  "lost-item-report": "surface-blue",
  "dmv-license": "surface-yellow",
  "laundry-machine": "surface-mint",
  "apartment-maintenance": "surface-lavender",
  "vet-visit": "surface-blue",
  "daycare-pickup": "surface-yellow",
  "community-event": "surface-mint",
  "delivery-wrong-order": "surface-lavender",
  "parking-ticket": "surface-blue",
};